/**
 * Amenity mapping from numeric IDs to API amenity group strings
 */
export enum AmenityApiMapping {
    Internet = 25,
    Parking = 6,
    Catering = 11,
    Tv = 2,
    SwimmingPool = 13,
    Sauna = 8,
    Playground = 12,
    Bicycle = 9,
    CardPayment = 17,
    Pets = 18,
}
